import { MutationTree, Mutation } from 'vuex';
import { IHit, IState } from './state';
import { ActionPayload } from './actions';

type MutationHandler<PayloadType> = (state: IState, payload: ActionPayload<PayloadType>) => any;

const setStateMutation: MutationHandler<IState> = (state, { payload }) => {
	Object.assign(state, payload);
}

const setQueryMutation: MutationHandler<string> = (state, { payload }) => {
	state.query = payload;
}

const setPageMutation: MutationHandler<number> = (state, { payload }) => {
	state.page = payload;
}

const setLoadingMutation: MutationHandler<boolean> = (state, { payload }) => {
	state.loading = payload;
}

const setHitsMutation: MutationHandler<IHit[]> = (state, { payload }) => {
	state.hits = payload;
}

const setSelectedBoardMutation: MutationHandler<string> = (state, { payload }) => {
	state.selectedBoard = payload;
}

const setSelectedPartyMutation: MutationHandler<string> = (state, { payload }) => {
	state.selectedParty = payload;
}

const setTotalMutation: MutationHandler<number> = (state, { payload }) => {
	state.total = payload;
}

const mutations: MutationTree<IState> = {
	setState: setStateMutation,
	setQuery: setQueryMutation,
	setPage: setPageMutation,
	setLoading: setLoadingMutation,
	setHits: setHitsMutation,
	setSelectedBoard: setSelectedBoardMutation,
	setSelectedParty: setSelectedPartyMutation,
	setTotal: setTotalMutation,
}

export default mutations
